import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Subscribe from "../views/Subscribe.vue";
import Room from "../views/Room.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      title: "Trast - Your no-nonsense streaming platform."
    },
    component: Home
  },
  {
    path: "/subscribe",
    name: "subscribe",
    meta: {
      title: "Subscribe"
    },
    component: Subscribe
  },
  {
    path: "/:user",
    name: "room",
    meta: {
      title: null
    },
    component: Room
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.title !== null) document.title = to.meta.title;
  next();
});

export default router;
